<template>

  <div class="hit-row">
  <div class="hit-col-md-3" :key="key">

    <div class="hit-form-group">
      <label class="hit-html-label" v-html="$t('message.backgroundImage')"/>

      <uploadImage
      v-bind:title="$t('message.edit', {name: $t('message.banner')})"
      :settings="{
        image: {dataUrl: vals.background_image},
        maxWidth: 1000,
        maxHeight: 1000,
        onSave: function(ret){ callback(ret.dataUrl); },
        debug: 0,
        accept: 'image/*'
      }"
      />
    </div>
    <div class="hit-text-right">
      <a href="#" class="hit-btn hit-btn-default hit-btn-xs" v-on:click.prevent="function(){ callback(''); vals.background_image = ''; key = new Date().getTime(); }"><hit_icon :id="'bin'" /></a>
    </div>

  </div>
  </div>

</template>

<script>

import uploadImage from '@core/components/content/landingpage/uploadImage'

export default{
  props: {vals: Object, callback: Function},
  data() {

    return {
      key: new Date().getTime()
    }
  },
  components: { uploadImage },

  methods:{

  }
}
</script>
